export const Lock = () => {
  return (
    <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4444 8H2.55556C1.69645 8 1 8.73262 1 9.63636V15.3636C1 16.2674 1.69645 17 2.55556 17H13.4444C14.3036 17 15 16.2674 15 15.3636V9.63636C15 8.73262 14.3036 8 13.4444 8Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 8V4.88889C4 3.85749 4.42143 2.86834 5.17157 2.13903C5.92172 1.40972 6.93913 1 8 1C9.06087 1 10.0783 1.40972 10.8284 2.13903C11.5786 2.86834 12 3.85749 12 4.88889V8"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
